import Collapse from '@material-ui/core/Collapse';
import MenuList from '@material-ui/core/MenuList';
import CarrierIcon from '@material-ui/icons/AirportShuttle';
import CalendarIcon from '@material-ui/icons/CalendarToday';
import DashboardIcon from '@material-ui/icons/Dashboard';
import FindInPageIcon from '@material-ui/icons/FindInPage';
import LogisticsIcon from '@material-ui/icons/LocalShipping';
import AdminIcon from '@material-ui/icons/Lock';
import UserIcon from '@material-ui/icons/PermIdentity';
import SyncIcon from '@material-ui/icons/Sync';
import * as React from 'react';
import { useMiaSelector } from '../../components/hooks';
import { LeftNavHeader } from '../../components/LeftNavHeader';
import { canEditWarehouseUsers, isAdmin, isItOverriddenByType, isUser } from '../../ducks/auth';
import { ShoreMasterDepartment } from '../../ducks/lookups';
import { getFullLogisticsUrl, LogisticsUrls } from '../../logistics/logisticsRoutes';
import { getUrl, NavTypes } from '../layoutConstants';
import { MenuLink } from '../MenuLink';

interface ILogisticsMenuProps {
  collapsed: boolean;
  menuClassName: string;
  navType: NavTypes;
  onExpandClick: (navType: NavTypes) => any;
  onNavClick: () => any;
  currentLocation: string;
}

let LogisticsMenu: React.FunctionComponent<ILogisticsMenuProps> = ({
  collapsed,
  menuClassName,
  onExpandClick,
  onNavClick,
  navType,
  currentLocation
}) => {
  const admin = useMiaSelector(state => isAdmin(state, 'logistics'));
  const user = useMiaSelector(state => isUser(state, 'logistics'));
  const isNavItOverridden = useMiaSelector(state => isItOverriddenByType(state, 'logistics'));

  const isWarehouseWriteUser = useMiaSelector(state => canEditWarehouseUsers(state, ShoreMasterDepartment.Logistics));

  React.useEffect(() => {
    if (currentLocation.includes('logistics')) {
      onExpandClick('logistics');
    }
  }, []);

  return (
    <>
      {user && (
        <>
          <LeftNavHeader
            collapsed={collapsed}
            navType={navType}
            onExpandClick={onExpandClick}
            icon={LogisticsIcon}
            title="Logistics"
            hasWarningColor={isNavItOverridden}
          />
          <Collapse component="li" in={collapsed} timeout="auto" unmountOnExit>
            <MenuList disablePadding>
              <MenuLink
                icon={<DashboardIcon />}
                to={getFullLogisticsUrl(LogisticsUrls.dashboard)}
                label="Dashboard"
                menuClassName={menuClassName}
                onNavClick={onNavClick}
                isActive={currentLocation === getFullLogisticsUrl(LogisticsUrls.dashboard)}
              />
              <MenuLink
                icon={<CalendarIcon />}
                to={getFullLogisticsUrl(LogisticsUrls.calendar)}
                label="Calendar"
                menuClassName={menuClassName}
                onNavClick={onNavClick}
                isActive={currentLocation === getFullLogisticsUrl(LogisticsUrls.calendar)}
              />
              <MenuLink
                icon={<CarrierIcon />}
                to={getFullLogisticsUrl(LogisticsUrls.carriers)}
                label="Carriers"
                menuClassName={menuClassName}
                onNavClick={onNavClick}
                isActive={currentLocation === getFullLogisticsUrl(LogisticsUrls.carriers)}
              />
              <MenuLink
                icon={<SyncIcon />}
                to={getFullLogisticsUrl(LogisticsUrls.syncEventLog)}
                label="Sync Event Log"
                menuClassName={menuClassName}
                onNavClick={onNavClick}
                isActive={currentLocation === getFullLogisticsUrl(LogisticsUrls.syncEventLog)}
              />
              <MenuLink
                icon={<FindInPageIcon />}
                to={getUrl.logisticsOrderLookup()}
                label="Order Lookup"
                menuClassName={menuClassName}
                onNavClick={onNavClick}
                isActive={currentLocation.includes(getUrl.logisticsOrderLookup())}
              />
              {isWarehouseWriteUser && (
                <MenuLink
                  icon={<UserIcon />}
                  to={getFullLogisticsUrl(LogisticsUrls.users)}
                  label="Users"
                  menuClassName={menuClassName}
                  onNavClick={onNavClick}
                  isActive={currentLocation === getFullLogisticsUrl(LogisticsUrls.users)}
                />
              )}
              {admin && (
                <MenuLink
                  icon={<AdminIcon />}
                  to={getFullLogisticsUrl(LogisticsUrls.admin)}
                  label="Admin"
                  menuClassName={menuClassName}
                  onNavClick={onNavClick}
                  isActive={currentLocation === getFullLogisticsUrl(LogisticsUrls.admin)}
                />
              )}
            </MenuList>
          </Collapse>
        </>
      )}
    </>
  );
};

LogisticsMenu = React.memo<ILogisticsMenuProps>(LogisticsMenu);
export { LogisticsMenu };
